import { Box, Grid, Typography } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ImageID004 from '../../../file/ID004.png'
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F7F7F9',
    ...theme.typography.body2,
    /*  padding: theme.spacing(1),  */
    color: theme.palette.text.secondary,
    boxShadow: 'none',
    minHeight: '100%',
    borderRadius: 20,
    position: 'relative'
}));
export default function BoxDialogID004() {
    return (
        <Box>
            <img src={ImageID004} alt="" className=' max-w-full max-h-[700px] rounded-lg m-auto ' />
        </Box>
    )
}
